import { render, staticRenderFns } from "./VAlert.vue?vue&type=template&id=4d12b168"
import script from "./VAlert.vue?vue&type=script&lang=ts"
export * from "./VAlert.vue?vue&type=script&lang=ts"
import style0 from "./VAlert.vue?vue&type=style&index=0&id=4d12b168&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports